export default __webpack_public_path__ + "static/media/concierge-mobile.da87fa88.png";